import styled from 'styled-components'

export const Container = styled.section`
  width: 100%;
  background-color: var(--color-secondary);
  display: flex;
  justify-content: center;
  color: #000;
`

export const Content = styled.div`
  max-width: 964px;
  min-height: 380px;
  padding: 2rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  text-align: center;

  h1 {
    font-size: 4rem;
    text-transform: uppercase;
    padding-bottom: 1rem;
    border-bottom: 2px solid #000;
    margin-bottom: 2rem;
    letter-spacing: 0.25rem;
    font-family: 'Bungee';
    font-weight: normal;
  }

  p {
    font-size: 1.6rem;
    margin: 0;
    line-height: 2rem;
  }

  @media only screen and (max-width: 768px) {
    h1 {
      font-size: 3.5rem;
      max-width: 750px;
    }
    p {
      font-size: 1.4rem;
    }
  }

  @media only screen and (max-width: 580px) {
    padding: 0 1rem;

    h1 {
      font-size: 2rem;
    }
    p {
      font-size: 1.2rem;
    }
  }
`
